// import '@coreui/icons/css/coreui-icons.min.css';
// import 'font-awesome/css/font-awesome.min.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/nova-light/theme.css';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createStore } from 'redux';
import App from './App';
// import Config                from './config/config';
import './index.css';
import baseReducer from './reducers/baseReducer';
import registerServiceWorker from './registerServiceWorker';
var store = createStore(baseReducer);
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(BrowserRouter, null,
        React.createElement(App, null))), document.getElementById('root'));
registerServiceWorker();



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 171
// module chunks = 0